import React, { useState, useEffect, useRef } from 'react'
import { Table, Text, Tooltip, Pane, Spinner } from 'evergreen-ui'
import { QuantitySelect } from './Materials'
import { Money } from '../Misc';
import { useCart } from '../Cart'

let TotalsTable = (props) => {



    return <Pane display="flex" flexDirection="column" textAlign="center" width="300px">
        <Table>
            <Table.Head>
                <Table.TextHeaderCell>Qty</Table.TextHeaderCell>
                <Table.TextHeaderCell>Each</Table.TextHeaderCell>
                <Table.TextHeaderCell>Line Total</Table.TextHeaderCell>
            </Table.Head>
            <Table.Body height={300}> {Object.keys(props.totals).map((k, i) =>
                <Table.Row key={i} height={24}>
                    <Table.TextCell>{k} </Table.TextCell>
                    <Table.TextCell> {(typeof props.totals[k] === "number") ? <><Money>{props.totals[k] / k}</Money>/ea</> : props.totals[k]}</Table.TextCell>
                    <Table.TextCell> {(typeof props.totals[k] === "number") ? <><Money>{props.totals[k]}</Money></> : props.totals[k]}</Table.TextCell>
                </Table.Row>)}
            </Table.Body>
        </Table>
    </Pane>
}

export function SubTotal(props) {

    let tbq = props.order.selMaterial && (props.order.selMaterial.Available == "On Request");
    if (props.order.welding || props.order.color || props.order.assembly) {
        tbq = true;
    }

    const setQty = (v) => {
        if (props.order.qty + v > 0) {
            let o = props.order;
            o.qty = v;
            props.setOrder({ ...o });
        }
    }

    // console.log("O: ", props.order)

    let { updating } = useCart();

    return (<Pane display="flex" flexDirection="column" textAlign="center" padding={24} >
        
        {props.order.selMaterial &&
            <Pane display="flex" flexDirection="column" textAlign="center" elevation={2} padding={8} marginBottom={16}>
                <Text>Quantity to order:</Text>
                <QuantitySelect qty={props.order.qty} onQtyChanged={(v) => { setQty(v) }} />
                <Pane marginBottom={"5px"}>
                    <Text><strong>Setup:</strong>    {props.order.SetupFee != null ?<Money>{props.order.SetupFee}</Money>:<i>Calcualted after adding to cart</i>}   </Text>
                </Pane>
                <Pane display="flex" padding={8}>
                    {!tbq && (typeof props.order.selMaterial.qtycost === "number") ?
                        <Pane flex={1} textAlign="left">

                            <Text marginBottom={5}><strong>Each:</strong> </Text>
                            <strong><Text marginBottom={5}>

                                <Money >{props.order.selMaterial.qtycost / props.order.qty}</Money></Text></strong>

                        </Pane> : ''}
                    <Pane>
                        <Text marginBottom={5}><strong>Total:</strong> </Text>
                        <strong>
                            <Text marginBottom={5}>{tbq ? 'To be Quoted' :
                                <Money>{parseFloat(props.order.selMaterial.qtycost)}</Money>}
                            </Text>
                        </strong>
                    </Pane>
                </Pane>

            </Pane>
        }


        {!tbq && props.order.selMaterial && props.order.selMaterial.totals &&
            <Pane elevation={1} marginTop={16}>
                <TotalsTable totals={props.order.selMaterial.totals} />
            </Pane>
        }



    </Pane>)
}